/**
 * API 响应时间采集器 [Claude Code]
 * 使用 IndexedDB 存储，支持大量数据、跨标签页共享
 * 自动清理策略：只保留最近 24 小时的记录
 */

const DB_NAME = '__api_log'
const STORE_NAME = 'records'
const DB_VERSION = 1
const MAX_AGE = 24 * 60 * 60 * 1000 // 24 小时自动清理 [Claude Code]

let dbPromise = null

/**
 * 打开/初始化 IndexedDB [Claude Code]
 */
function _getDb () {
  if (dbPromise) return dbPromise
  // jsdom / SSR 等环境不提供 indexedDB，直接返回 reject 避免整个模块加载期崩溃 [Claude Code]
  if (typeof indexedDB === 'undefined') {
    dbPromise = Promise.reject(new Error('indexedDB unavailable'))
    // 静默吞掉 unhandledRejection，避免污染测试输出 [Claude Code]
    dbPromise.catch(() => {})
    return dbPromise
  }
  dbPromise = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION)
    req.onupgradeneeded = (e) => {
      const db = e.target.result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true })
      }
    }
    req.onsuccess = () => resolve(req.result)
    req.onerror = () => reject(req.error)
  })
  return dbPromise
}

/**
 * 记录一条请求 [Claude Code]
 */
async function addRecord ({ method, url, startTime, endTime, duration, status, success }) {
  const path = url.split('?')[0]
  const db = await _getDb()
  const tx = db.transaction(STORE_NAME, 'readwrite')
  tx.objectStore(STORE_NAME).add({
    method: (method || 'GET').toUpperCase(),
    path,
    fullUrl: url,
    startTime,
    endTime,
    duration,
    status,
    success
  })
}

/**
 * 获取所有记录 [Claude Code]
 */
async function getRecords () {
  const db = await _getDb()
  return new Promise((resolve) => {
    const tx = db.transaction(STORE_NAME, 'readonly')
    const req = tx.objectStore(STORE_NAME).getAll()
    req.onsuccess = () => resolve(req.result || [])
    req.onerror = () => resolve([])
  })
}

/**
 * 清空所有记录 [Claude Code]
 */
async function clear () {
  const db = await _getDb()
  const tx = db.transaction(STORE_NAME, 'readwrite')
  tx.objectStore(STORE_NAME).clear()
}

/**
 * 清理超过 24 小时的旧记录 [Claude Code]
 */
async function cleanup () {
  const cutoff = Date.now() - MAX_AGE
  const all = await getRecords()
  const stale = all.filter(r => r.endTime < cutoff)
  if (!stale.length) return
  const db = await _getDb()
  const tx = db.transaction(STORE_NAME, 'readwrite')
  const store = tx.objectStore(STORE_NAME)
  stale.forEach(r => store.delete(r.id))
}

// 启动时清理一次过期数据 [Claude Code]
if (typeof window !== 'undefined' && typeof indexedDB !== 'undefined') {
  _getDb().then(() => cleanup()).catch(() => {})
  window.__apiStats = { getRecords, clear, cleanup }
}

export default { addRecord, getRecords, clear, cleanup }
